var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"has-text-grey"},[_vm._v("Vehicle overview")]),_c('div',[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column"},[_c('span',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.description)+" ")])])])]),_c('Grid',{attrs:{"data":_vm.grid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }